import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import Imagez from '../lib/reusable/Imagez';
import Button from '@mui/material/Button';
import { COLORS } from '../utils/colors';

const ButtonFullPage = styled.div`
  position: relative;
  padding: 0;
  margin: 0;
  border: none;
  display: flex;
  height: 100%;
  width: 100%;
  align-items: flex-start;
  flex-direction: column;
  z-index: 3;
  overflow: scroll;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const EditImage = (props) => {
  const {
    image,
    setFieldValue,
    setFile,
    file,
    initialImage,
    height,
    disabled,
    removeImage,
    setRemoveImage,
  } = props;
  const [errorImage, setErrorImage] = useState(false);

  useEffect(() => {
    if (image?.local && errorImage) {
      setErrorImage(false);
    }
  }, [image]);

  const handleNoImage = () => {
    setErrorImage(true);
  };

  const hasImage = image?.image !== null && !errorImage;

  return (
    <div style={{ position: 'relative' }}>
      <ButtonFullPage style={{ backgroundColor: COLORS.S_BG, borderRadius: '6px' }}>
        {hasImage && !removeImage ? (
          <ImageWrapper>
            <Imagez
              br="0px 0px 0px 0px"
              image={
                image?.local && image?.image !== undefined
                  ? URL.createObjectURL(image.image)
                  : image?.image
                  ? image?.image
                  : null
              }
              height={height}
              handleNoImage={handleNoImage}
            />
          </ImageWrapper>
        ) : (
          <div
            style={{
              height,
              width: '100%',
              backgroundColor: COLORS.S_BG,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div>NO IMAGE UPLOADED</div>
          </div>
        )}
      </ButtonFullPage>
      <div style={{ position: 'absolute', bottom: '15px', left: '15px', zIndex: 90 }}>
        <input
          disabled={disabled}
          accept="image/jpeg"
          id="contained-button-file"
          type="file"
          onChange={(event) => {
            setRemoveImage(false);
            if (event.currentTarget.files[0]) {
              setFile(event.currentTarget.files[0])
              setFieldValue('image', {
                image: event.currentTarget.files[0],
                local: true,
              });
            }
          }}
          style={{ display: 'none' }}
        />
        {!removeImage && hasImage && (
          <Button
            disabled={disabled}
            variant="contained"
            color="secondary"
            component="span"
            onClick={() => {
              setFile(null);
              setFieldValue('image', { image: initialImage, local: false });
              setRemoveImage(true);
            }}
          >
            REMOVE
          </Button>
        )}
      </div>
      <div style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 90 }}>
        <label htmlFor="contained-button-file">
          <Button variant="contained" color="primary" component="span" disabled={disabled}>
            UPLOAD NEW PHOTO
          </Button>
        </label>
      </div>
    </div>
  );
};
